import Environment from "../../../environment";

import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { ComprobanteService } from 'services/ComprobanteService';
import { UnidadService } from 'services/UnidadService';
import useRequest from 'hooks/useRequest';
import { useStore, useStorePersist } from "store/context";

import numberFormatter from 'hooks/numberFormatter';

import GradientButton from 'components/atoms/GradientButton';
import MainLayout from 'components/Layouts/MainLayout';

import SearchSelect from 'components/atoms/SearchSelect';

import Box from "components/atoms/Box";
import Table from 'react-bootstrap/Table';

import descarga from 'assets/images/descarga.png';

import './styles.scss';

import { es } from 'date-fns/locale'
import DatePicker from "react-datepicker";
import { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const PagosRealizadosView = (props) => {
    registerLocale('es', es);

    const history = useHistory();

    const {
        loadingSpinner, 
        beforeSubmit, afterSubmit, showSuccess, showError,
        dealWithError
    } = useRequest();

    const {
        currency
    } = numberFormatter();

    const [comprobantes, setComprobantes] = useState([]);

    const [{
        uf,  // La uf actual seleccionada
    }, dispatch] = useStore();

    const [{
        unidades
    }, dispatchPersist] = useStorePersist();

    const [startDate, setStartDate] = useState(yearBefore(new Date()));
    const [endDate, setEndDate] = useState(new Date());

    useEffect(() => {
        if (!unidades || unidades.length === 0) {
            getUnidades();
        }

        var wrapper1 = document.getElementById('wrapper1');
        var wrapper2 = document.getElementsByClassName('table-responsive')[0];
        var table = wrapper2.querySelector('.table');
        document.getElementById("div1").style.width = table.offsetWidth;

        wrapper1.onscroll = function () {
            console.log('wrapper1');
            wrapper2.scrollLeft = wrapper1.scrollLeft;
        };
        wrapper2.onscroll = function () {
            console.log('wrapper2');
            wrapper1.scrollLeft = wrapper2.scrollLeft;
        };
    }, []);

    useEffect(() => {
        if (!uf) {
            return;
        }
        beforeSubmit();
        
        const data = {
            fh_desde: formatDate(startDate),
            fh_hasta: formatDate(endDate),
        }
        ComprobanteService.comprobantes(uf.id, data)
            .then(data => {
                afterSubmit();
                showSuccess('Comprobantes obtenidos');
                data.reverse();
                setComprobantes(data);
            }).catch((error) => {
                dealWithError(error, 'Error al obtener comprobantes');
            });
    }, [uf]);

    const handleChange = (uf) => {
        const filtrada = unidades.find(filtrada => filtrada.unidad === uf);
        dispatch({
            type: 'setUf',
            payload: filtrada,
        });
    };


    const getUnidades = () => {
        beforeSubmit();
        UnidadService.unidades({})
            .then((unidades) => {
                afterSubmit();
                dispatch({
                    type: 'setUnidades',
                    payload: unidades
                });

                if (unidades.length > 0) {
                    dispatch({
                        type: 'setUf',
                        payload: unidades[0],
                    });
                } else {
                    showError("No sé puede cargar la unidad de pagos-realizados")
                }
            }).catch((error) => {
                afterSubmit();
            });
    }

    const buscar = () => {
        beforeSubmit();

        const data = {
            fh_desde: formatDate(startDate),
            fh_hasta: formatDate(endDate),
        }
        
        ComprobanteService.comprobantes(uf.id, data)
            .then(data => {
                afterSubmit();
                showSuccess('Comprobantes obtenidos');
                data.reverse();
                setComprobantes(data);
            }).catch((error) => {
                dealWithError(error, 'Error al obtener comprobantes');
            });
    }

    function yearBefore(date) {
        return date.setFullYear(date.getFullYear() - 1);
    }

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }

    const consultaYDescarga = (e) => {
        e.preventDefault();

        history.push('/consulta_descarga_facturas');
    };

    const descargarComprobantes = (e) => {
        e.preventDefault();

        
        let fh_desde = formatDate(startDate);
        let fh_hasta = formatDate(endDate);

        window.open(`${Environment.api}api/unidades-facturaciones/${uf.id}/comprobantes-cobrados/imprimir?fh_desde=${fh_desde}&fh_hasta=${fh_hasta}`, "_blank")
    };

    return (
        <MainLayout>
            {unidades && <SearchSelect onChange={handleChange} options={unidades} value={uf}></SearchSelect>}
            <div className="pagos-realizados-container">
                <div className="pagos-realizados-volver">
                    <GradientButton legend={'VOLVER'} handleClick={consultaYDescarga}/>
                </div>
                <div className="pagos-realizados-buscador">
                    <form onSubmit={buscar}>
                        <div className="pagos-realizados-desde">
                            <p>Desde: </p>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={startDate}
                                onChange={date => { setStartDate(date); setEndDate(date > endDate ? date : endDate)}}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                locale="es"
                            />
                            
                        </div>
                        <div className="pagos-realizados-hasta">
                            <p>Hasta: </p>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={endDate}
                                onChange={date => setEndDate(date)}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                locale="es"
                            />
                        </div>
                        <div className="pagos-realizados-botones">
                            <div className="pagos-realizados-buscar">
                                <GradientButton legend={'BUSCAR'} handleClick={buscar}/>
                            </div>
                            <div className="pagos-realizados-descargar">
                                {comprobantes.length > 0 && <GradientButton legend={'DESCARGAR'} handleClick={descargarComprobantes}/>}
                            </div>
                        </div>
                    </form>
                </div>
                <div className="pagos-realizados-box">
                    <Box header='PAGOS REALIZADOS' body={
                            <div className="pagos-realizados-listado">
                                <div id="wrapper1">
                                    <div id="div1">
                                    </div>
                                </div>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>TIPO</th>
                                            <th>FACTURA Nª</th>
                                            <th>PERÍODO</th>
                                            <th>FECHA PAGO</th>
                                            <th class="montos">DEUDA ORIG.</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {!loadingSpinner && <tbody>
                                        {comprobantes.map((comprobante) => {
                                                return <tr>
                                                    <td className="tipo" title={comprobante.tipo_full}>{comprobante.tpo_com}</td>
                                                    <td>{comprobante.comprobante}</td>
                                                    <td>{comprobante.per_has}</td>
                                                    <td>{comprobante.fh_cobro}</td>
                                                    <td class="montos">$ {currency.format(comprobante.importe)}</td>
                                                    <td>
                                                        {<a target="_blank" href={`${Environment.api}api/unidades-facturaciones/${uf.unidad}/comprobantes/${comprobante.comprobante}/imprimir`} className="descarga">
                                                            <img src={descarga} alt="descarga" />
                                                        </a>}
                                                    </td>
                                                </tr>
                                            ;
                                        })}
                                        {comprobantes.length === 0 &&
                                            <p className="messages">No existen pagos para la unidad de facturación en el rango de fechas seleccionado</p>
                                        }
                                    </tbody>}
                                </Table>
                            </div>
                    }>
                    </Box>
                </div>
            </div>
        </MainLayout>
    );
}

export default withTranslation()(PagosRealizadosView);